import { useContext, useEffect, useState } from "react";
import {
  apiService,
  campaignService,
  regexService,
  templateService,
  userService,
} from "../../service";
import { loaderContext, notificationContext } from "../../context/context";
import { useModal } from "../../hooks";
import { Modal } from "../../components";
import dateFormat from "../../utils/dateFormat";
import { StatusChip } from "../../utils/chipUtils";
import numberFormat from "../../utils/numberFormat";
import {
  DatePicker,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const initialState = {
  allow_edit: false,
  due_date: dayjs().format("YYYY-MM-DD"),
  expiry_date: dayjs().format("YYYY-MM-DD"),
};

const templateState = {
  pop_desc: "",
  sms_templateid: "",
  email_templateid: "",
  whatsapp_templateid: "",
  sms_content: "",
  email_content: "",
  whatsapp_content: "",
};

const initParamState={
  param1:"dueamount"
}

function CreateInvoice() {
  const { showLoader, hideLoader } = useContext(loaderContext);
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [paymentPurpose, setPaymentPurpose] = useState();
  const [templateDetails, setTemplateDetails] = useState(templateState);

  const [smsTemplate, setSMSTemplate] = useState();
  const [emailTemplate, setEmailTemplate] = useState();
  const [wsTemplate, setWSTemplate] = useState();
  const [invoiceResponse, setInvoiceResponse] = useState();
  const [popValue, setPOPValue] = useState();
  const [smsContent, setSMSContent] = useState();
  const [emailContent, setEmailContent] = useState();
  const [wsContent,setWsContent]=useState()
  const [paramKey, setParamKey] = useState(initParamState);
  const [param, setParam] = useState({});

  const toast = useContext(notificationContext);

  const [isError, setError] = useState();

  const templateMismatchModal = useModal();

  const previewModal = useModal();

  const getTemplates = async () => {
    const smsTempalteResponse = await templateService.getSMSTemplates();
    const emailTempalteResponse = await templateService.getEmailTemplates();
    const whatsappTemplateResponse = await templateService.getWSTemplates();

    if (smsTempalteResponse?.data) {
      setSMSTemplate(smsTempalteResponse?.data);
    }
    if (emailTempalteResponse?.data) {
      setEmailTemplate(emailTempalteResponse?.data);
    }
    if (whatsappTemplateResponse?.data) {
      setWSTemplate(whatsappTemplateResponse?.data);
    }
  };

  const setInputValue = (e) => {
    if (
      e.target.id === "sms_comm" ||
      e.target.id === "email_comm" ||
      e.target.id === "whatsapp_comm"
    ) {
      setTemplateDetails({
        ...templateDetails,
        [e.target.id]: e.target.checked,
      });
      setInvoiceData(
        {
          ...invoiceData,
        [e.target.id]: e.target.checked,
        }
      )
    } else {
      setInvoiceData({
        ...invoiceData,
        [e.target.id]: e.target.value,
      });
    }
  };

  const setRadioValue = (e) => {
    setInvoiceData({
      ...invoiceData,
      [e.target.id]: e.target.checked,
    });
  };

  const setParamValue = (e) => {
    if (e.target.id === "param4") {
      setParam({
        ...param,
        param1: (param["param5"] || 0) + parseInt(e.target.value || 0),
        [e.target.id]: parseInt(e.target.value),
      });
    } else if (e.target.id === "param5") {
      setParam({
        ...param,
        param1: (param["param4"] || 0) + parseInt(e.target.value || 0),
        [e.target.id]: parseInt(e.target.value),
      });
    } else if (
      e.target.id === "param1" &&
      (param["param4"] || param["param5"])
    ) {
      setParam({
        ...param,
        param1: (param["param4"] || 0) + (param["param5"] || 0),
      });
    } else {
      setParam({
        ...param,
        [e.target.id]: e.target.value,
      });
    }
  };

  const handleMessageContent = (type, templateid) => {
    setParamKey(initParamState)
    var tempParam = initParamState;
    // if (type === "SMS") {
      if (document?.getElementById("sms_comm")?.checked) { 
          const smstemplate =
            smsTemplate?.find((data) => data.template_id === document.getElementById("sms_comm").value) || "";
          smstemplate?.params &&
            Object.keys(smstemplate.params).map((e) => {
              if (smstemplate.params[e]) {
                tempParam = {
                  ...tempParam,
                  [`${e}`]: smstemplate.params[e],
                };
              }
            });
          // setParamKey({
          //   ...paramKey,
          //   ...tempParam            
          // });
          setSMSContent(smstemplate);
          // console.log("sms",tempParam);
        }
    // }
    // if (type === "EMAIL") {
      if (document?.getElementById("email_comm")?.checked) {          
        const emailtemplate =
          emailTemplate?.find((data) => data.template_id === document.getElementById("email_comm").value) || "";
          emailtemplate?.params &&
            Object.keys(emailtemplate.params).map((e) => {
              if (emailtemplate.params[e]) {
                tempParam = {
                  ...tempParam,
                  [`${e}`]: emailtemplate.params[e],
                };
              }
            });
          // setParamKey({
          //   ...paramKey,
          //   ...tempParam            
          // });
          setEmailContent(emailtemplate);
          // console.log("email",tempParam);
        }
    // }
    // if (type === "WHATSAPP") {
      if (document?.getElementById("whatsapp_comm")?.checked) {          
        const wstemplate =
          wsTemplate?.find((data) => data.template_id ===  document.getElementById("whatsapp_comm").value) || "";
            wstemplate?.params &&
            Object.keys(wstemplate.params).map((e) => {
              if (wstemplate.params[e]) {
                tempParam = {
                  ...tempParam,
                  [`${e}`]: wstemplate.params[e],
                };
              }
            });
          // setParamKey({
          //   ...paramKey,
          //   ...tempParam            
          // });
        setWsContent(wstemplate);
        // console.log("ws",tempParam);
        }
        setParamKey(tempParam)
    // }
  };

  useEffect(() => {
    var tmpParam = {};
    Object.keys(paramKey).map((e) => {
      if (paramKey[e]!=="link") {        
        tmpParam = {
          ...tmpParam,
          [`${e}`]: param[e] || "",
        };
      }
    });
    setParam(tmpParam);
    tmpParam = {};
  }, [paramKey]);

  // useEffect(() => {
  //   console.log(invoiceData);
  //   console.log(templateDetails);
  //   console.log(param);
  // }, [invoiceData,templateDetails,param]);

  const handleSubmit = () => {
    if (
      invoiceData?.sms_template_name !== invoiceData?.email_template_name &&
      invoiceData?.comm_type === "BOTH"
    ) {
      templateMismatchModal.showModal();
      return;
    }
    submitInvoice();
  };

  const submitInvoice = async () => {
    // templateMismatchModal.hideModal();
    setInvoiceResponse();
    showLoader();
    try {
      const response = await campaignService.createInvoice({
        ...invoiceData,
        ...param,
      });
      if (response.data) {
        setInvoiceResponse(response.data);
        toast.success("Invoice Created Successfully");
      } else {
        throw response;
      }
    } catch (error) {
      toast.error("Technical Error,  Please check after some times.");
    } finally {
      hideLoader();
    }
  };

  const clearInvoice = () => {
    setError([]);
    setInvoiceResponse();
    setInvoiceData(initialState);
    setParamKey(initParamState)
    setParam({});
    setPaymentPurpose(popValue)
    setTemplateDetails({})
    setSMSContent();
    setEmailContent();
    getPaymentPurpose();
    (!smsTemplate || !emailTemplate) && getTemplates();
  };

  const validateForm = () => {
    setError([]);
    if (!invoiceData?.customer_name) {
      setError((e) => [...e, "req_name"]);
    }
    if (!invoiceData?.mobile_no || invoiceData?.mobile_no?.length < 10) {
      setError((e) => [...e, "req_mobile_num"]);
    }
    if (!invoiceData?.email_id) {
      setError((e) => [...e, "req_email_id"]);
    }
    if (invoiceData?.email_id) {
      !regexService.isEmail(invoiceData.email_id) &&
        setError((e) => [...e, "req_email_id"]);
    }
    if (!invoiceData?.due_date) {
      setError((e) => [...e, "req_due_date"]);
    }
    if (!invoiceData?.expiry_date) {
      setError((e) => [...e, "req_exp_date"]);
    }
    if (!invoiceData?.order_desc) {
      setError((e) => [...e, "req_order_desc"]);
    }
    // if (templateDetails?.sms_comm || templateDetails?.email_comm) {
      Object.keys(param)?.map((e) => {
        if (e == "param1" && param?.param1 == 0) {
          setError((err) => [...err, e]);
        } else if (!param[e]) {
          setError((err) => [...err, e]);
        }
      });
    // }
    // if (invoiceData?.comm_type) {
    //   if (
    //     invoiceData?.comm_type === "SMS" ||
    //     invoiceData?.comm_type === "BOTH"
    //   ) {
    //     if (!invoiceData?.sms_templateid) {
    //       setError((e) => [...e, "req_sms_templ_id"]);
    //     }
    //     if (invoiceData?.sms_templateid && smsContent?.params) {
    //       Object.keys(smsContent.params).map((e) => {
    //         if (
    //           smsContent.params[e] &&
    //           smsContent.params[e] !== "link" &&
    //           smsContent.params[e] !== ""
    //         ) {
    //           if (!param[e]) {
    //             setError((err) => [...err, e]);
    //           } else if (e == "param1" && param?.param1 == 0) {
    //             setError((err) => [...err, e]);
    //           }
    //         }
    //       });
    //     }
    //   }
    //   if (
    //     invoiceData?.comm_type === "EMAIL" ||
    //     invoiceData?.comm_type === "BOTH"
    //   ) {
    //     if (!invoiceData?.email_templateid) {
    //       setError((e) => [...e, "req_email_templ_id"]);
    //     }
    //     if (invoiceData?.email_templateid && emailContent?.params) {
    //       Object.keys(emailContent.params).map((e) => {
    //         if (
    //           emailContent.params[e] &&
    //           emailContent.params[e] !== "link" &&
    //           emailContent.params[e] !== ""
    //         ) {
    //           if (!param[e]) {
    //             setError((err) => [...err, e]);
    //           }
    //         }
    //       });
    //     }
    //   }
    //   if (invoiceData?.comm_type === "LINK") {
    //     if (!invoiceData?.param1 || invoiceData?.param1 == 0) {
    //       setError((e) => [...e, "req_amount"]);
    //     }
    //   }
    // }
    // if (invoiceData?.param1 == 0) {
    //   setError((e) => [...e, "req_amount"]);
    // }
  };

  const setNotificationDetail = (popIndex = null) => {
    setParamKey(initParamState)
        // setParam({})
    setTemplateDetails({
      ...templateState,
      pop_desc: paymentPurpose?.[popIndex]?.purpose_desc || "",
      sms_templateid: paymentPurpose?.[popIndex]?.sms_template_id || "",
      email_templateid: paymentPurpose?.[popIndex]?.email_template_id || "",
      whatsapp_templateid:
        paymentPurpose?.[popIndex]?.whatsapp_template_id || "",
    });
    setInvoiceData(
      {
        ...invoiceData,
        order_desc:paymentPurpose?.[popIndex]?.purpose_desc || "",
        sms_templateid: paymentPurpose?.[popIndex]?.sms_template_id || "",
        email_templateid: paymentPurpose?.[popIndex]?.email_template_id || "",
        whatsapp_templateid:
        paymentPurpose?.[popIndex]?.whatsapp_template_id || ""
      }
    )
    setPOPValue(paymentPurpose?.[popIndex] || []);
    setSMSContent();
    setEmailContent();
  };

  const getPaymentPurpose = async () => {
    const data = { merc_id: userService.userData.mercid, Templatetype: "" };
    const response = await apiService.fetchData(data, "getallpurpose");
    setPaymentPurpose(response?.data || []);
  };

  useEffect(() => {
    setNotificationDetail(paymentPurpose?.length > 0 ? 0 : null);
  }, [paymentPurpose]);

  useEffect(() => {
    validateForm();
  }, [invoiceData, param, templateDetails]);

  useEffect(() => {
    getPaymentPurpose();
    (!smsTemplate || !emailTemplate) && getTemplates();
  }, []);


  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <div>
          <h5>Create Invoice</h5>
        </div>
      </div>
      {(invoiceResponse && (
        <div className="mt-4">
          <div className="card p-2 border rounded-border-sm">
            <div className="flex-center justify-content-between">
              <h6>Invoice Created Successfully</h6>
              <div className="icon">
                <span class="material-symbols-outlined text-success">
                  verified
                </span>
              </div>
            </div>
            <div className="my-3">
              <p className="f-600">Invoice ID : {invoiceResponse?.invoiceno}</p>
            </div>
            <div className="flex-nowrap justify-content-between">
              <div className="input-wrapper">
                <p className="title">Pay Amount</p>
                <p>
                  {numberFormat(
                    invoiceResponse?.amount || invoiceResponse?.Amount
                  )}
                </p>
              </div>
              <div className="input-wrapper">
                <p className="title">Created on</p>
                <p>{dateFormat(invoiceResponse?.invoicedate)}</p>
              </div>
            </div>
            <div className="flex-nowrap justify-content-between">
              {/* <div className="input-wrapper">
                <p className="title">Notification Type</p>
                <p>{invoiceResponse?.smscomm==="Y"&&"SMS"}</p>
                <p>{invoiceResponse?.emailcomm==="Y"&&"Email"}</p>
                <p>{invoiceResponse?.whatsappcomm==="Y"&&"Whatsapp"}</p>
              </div> */}
              {invoiceResponse?.notificationtype?.toLowerCase() !== "link" && (
                <div className="input-wrapper">
                  <p className="title">Delivery status</p>
                  <p className="flex-center gap-md">
                    <DeliveryChip
                      sms={invoiceResponse?.smscomm}
                      email={invoiceResponse?.emailcomm}
                      ws={invoiceResponse?.whatsappcomm}
                      smsStatus={invoiceResponse?.smsStatus}
                      emailStatus={invoiceResponse?.mailresult}
                      whatsappStatus={invoiceResponse?.whatsappStatus}
                    />
                  </p>
                </div>
              )}
            </div>
            <div className="input-wrapper">
              <p className="title">Pay Link</p>
              <p>{invoiceResponse?.responsepageURL}</p>
            </div>
          </div>
          <div className="mt-2 text-right">
            <p
              className="text-primary f-600 cursor-pointer"
              onClick={() => clearInvoice()}
            >
              Create New Invoice
            </p>
          </div>
        </div>
      )) || (
        <>
          <div className="card border rounded-border-sm  mt-4">
            <div className="p-2 border-bottom">
              <p className="f-500">Customer Details</p>
            </div>
            <div className="p-2 mt-3">
              <div className="flex-wrap justify-content-between fc">
                <div className="fc-5">
                  <div className="input-wrapper">
                    <p className="input-title">Customer Name</p>
                    <label className="input">
                      <input
                        type="text"
                        placeholder="Customer Name"
                        id="customer_name"
                        value={invoiceData.customer_name}
                        onChange={(e) => {
                          regexService.isString(e.target.value) &&
                            setInputValue(e);
                        }}
                      />
                    </label>
                    {isError?.includes("req_name") && (
                      <p className="help-text text-danger mt-1">
                        Name required*
                      </p>
                    )}
                  </div>
                </div>
                <div className="fc-5">
                  <div className="input-wrapper">
                    <p className="input-title">Customer ID</p>
                    <label className="input">
                      <input
                        type="text"
                        placeholder="Customer ID"
                        id="customer_id"
                        value={invoiceData.customer_id}
                        onChange={(e) => {
                          regexService.isUserID(e.target.value) &&
                            setInputValue(e);
                        }}
                      />
                    </label>
                  </div>
                </div>
                <div className="fc-5">
                  <div className="input-wrapper">
                    <p className="input-title">Mobile No</p>
                    <label className="input">
                      <input
                        type="text"
                        placeholder="Mobile No"
                        id="mobile_no"
                        value={invoiceData.mobile_no}
                        onChange={(e) => {
                          regexService.isMobileNum(e.target.value) &&
                            setInputValue(e);
                        }}
                      />
                    </label>
                    {isError?.includes("req_mobile_num") && (
                      <p className="help-text text-danger mt-1">
                        Mobile number required*
                      </p>
                    )}
                  </div>
                </div>
                <div className="fc-5">
                  <div className="input-wrapper">
                    <p className="input-title">Email Id</p>
                    <label className="input">
                      <input
                        type="text"
                        placeholder="Email Id"
                        id="email_id"
                        value={invoiceData.email_id}
                        onChange={(e) => {
                          regexService.validateEmail(e.target.value) &&
                            setInputValue(e);
                        }}
                      />
                    </label>
                    {isError?.includes("req_email_id") && (
                      <p className="help-text text-danger mt-1">
                        Email Id required*
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card border rounded-border-sm  mt-4">
            <div className="p-2 border-bottom">
              <p className="f-500">Payments and Communication Config</p>
            </div>
            <div className="p-2 my-3">
              <div className="fc">
                <div className="flex-wrap justify-content-between">
                  <div className="fc-5">
                    <div className="input-wrapper">
                      <p className="input-title">Link Expiry</p>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileDatePicker
                          className="date-picker"
                          format="DD-MM-YYYY"
                          value={dayjs(invoiceData?.expiry_date)}
                          minDate={dayjs()}
                          maxDate={dayjs().add(999, "hour")}
                          id="expiry_date"
                          closeOnSelect
                          onChange={(value) => {
                            setInvoiceData({
                              ...invoiceData,
                              expiry_date: dayjs(value).format("YYYY-MM-DD"),
                            });
                          }}
                          onError={() => {
                            setInvoiceData({
                              ...invoiceData,
                              expiry_date: dayjs().format("YYYY-MM-DD"),
                            });
                          }}
                        />
                      </LocalizationProvider>
                      {isError?.includes("req_exp_date") && (
                        <p className="help-text text-danger mt-1">
                          Expiry date required*
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="fc-5">
                    <div className="input-wrapper">
                      <p className="input-title">Allow Payment Edit</p>
                      <label class="switch">
                        <input
                          type="checkbox"
                          defaultChecked={false}
                          id="allow_edit"
                          value={invoiceData.allow_edit}
                          onChange={(e) => setRadioValue(e)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {previewModal?.isModal && (
            <Modal>
              <div className="modal modal--md h-100">
                <div className="modal-head border-bottom">
                  <h6>Email Template Preview</h6>
                  <div className="icon" onClick={previewModal.hideModal}>
                    <span class="material-symbols-rounded">close</span>
                  </div>
                </div>
                <div className="modal-body p-0">
                  <iframe
                    srcDoc={contentPreview(emailContent?.mail_content, param)}
                    className="p-3"
                  ></iframe>
                </div>
              </div>
            </Modal>
          )}
          {templateMismatchModal?.isModal && (
            <Modal>
              <div className="modal modal--sm rounded-border-sm">
                <div className="modal-head border-bottom">
                  <h6>Template Mismatch</h6>
                  <div
                    className="icon"
                    onClick={templateMismatchModal.hideModal}
                  >
                    <span class="material-symbols-rounded">close</span>
                  </div>
                </div>
                <div className="modal-body">
                  Note*
                  <br />
                  You are trying to create invoice with different templates. Are
                  you sure you want to continue.
                </div>
                <div className="modal-foot flex-center justify-content-end">
                  <button
                    className="btn-primary btn--sm"
                    onClick={submitInvoice}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </Modal>
          )}
          <div className="card border rounded-border-sm  mt-4">
            <div className="p-2 border-bottom">
              <p className="f-500">Choose Template</p>
            </div>
            <div className="p-2 my-3">
              <div className="fc">
                <div className="flex-wrap justify-content-between">
                  <div className="fc-5">
                    <div className="input-wrapper">
                      <p className="input-title">Purpose of Payment</p>
                      {(paymentPurpose?.length > 0 && (
                        <>
                          <label className="select input-wrapper">
                            <select
                              onChange={(e) =>
                                setNotificationDetail(e.target.value)
                              }
                            >
                              {paymentPurpose?.map((e, index) => (
                                <option value={index}>{e.purpose_desc}</option>
                              ))}
                            </select>
                          </label>
                          <div className="flex gap-lg">
                            {invoiceData?.sms_templateid && (
                              <label className="input-radio-grp">
                                <input
                                  type="checkbox"
                                  id="sms_comm"
                                  defaultChecked={false}
                                  checked={templateDetails?.sms_comm}
                                  value={invoiceData?.sms_templateid}
                                  onChange={(e) => {
                                    setInputValue(e);
                                    handleMessageContent(
                                      "SMS",
                                      e?.target?.value
                                    );
                                  }}
                                />
                                SMS
                              </label>
                            )}
                            {invoiceData?.email_templateid && (
                              <label className="input-radio-grp">
                                <input
                                  type="checkbox"
                                  defaultChecked={false}
                                  checked={templateDetails?.email_comm}
                                  id="email_comm"
                                  value={invoiceData?.email_templateid}
                                  onChange={(e) => {
                                    setInputValue(e);
                                    handleMessageContent(
                                      "EMAIL",
                                      e?.target?.value
                                    );
                                  }}
                                />
                                Email
                              </label>
                            )}
                            {invoiceData?.whatsapp_templateid && (
                              <label className="input-radio-grp">
                                <input
                                  type="checkbox"
                                  id="whatsapp_comm"
                                  checked={invoiceData?.whatsapp_comm}
                                  defaultChecked={false}
                                  value={popValue?.whatsapp_template_id}
                                  onChange={(e) => {
                                    setInputValue(e);
                                    handleMessageContent(
                                      "WHATSAPP",
                                      e?.target?.value
                                    );
                                  }}
                                />
                                Whatsapp
                              </label>
                            )}
                          </div>
                        </>
                      )) || (
                        <div>
                          <p className="help-text text-danger mt-1">
                            No Template Found*
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="fc flex-wrap fc-12 justify-content-between">
                    {
                    // (templateDetails?.sms_comm ||
                    //   templateDetails?.email_comm) &&
                      Object?.keys(paramKey)?.map((key) => {
                        if (paramKey[key] !== "link") {
                          return (
                            <div className="input-wrapper fc-5">
                              <p className="title">
                                {paramKey[key]} - ({key})
                              </p>
                              <div className="input-wrapper">
                                <label className="input">
                                  <input
                                    type="text"
                                    id={key}
                                    value={param[key] || ""}
                                    onChange={(e) => {
                                      if (
                                        ["param1", "param4", "param5"].includes(
                                          key
                                        ) &&
                                        regexService.isAmount(e.target.value)
                                      ) {
                                        setParamValue(e);
                                      } else if (
                                        ![
                                          "param1",
                                          "param4",
                                          "param5",
                                        ].includes(key) &&
                                        regexService.isAlphaNum(e.target.value)
                                      ) {
                                        setParamValue(e);
                                      }
                                      {
                                      }
                                    }}
                                  />
                                </label>
                                {isError?.includes(key) && (
                                  <p className="help-text text-danger mt-1">
                                    Required field*
                                  </p>
                                )}
                              </div>
                            </div>
                          );
                        }
                      }
                      )
                      }
                    {/* <div className="fc-5">
                      {invoiceData?.email_comm && (
                        <div className="input-wrapper">
                          <p className="input-title">Email Template</p>
                          <div className="input-wrapper">
                            {emailContent &&
                              emailContent?.params &&
                              Object?.keys(emailContent.params).map((key) => {
                                if (
                                  emailContent.params[key] &&
                                  emailContent.params[key] !== "" &&
                                  emailContent.params[key] !== "link" &&
                                  emailContent.params[key] !== "name"
                                ) {
                                  return (
                                    <>
                                      <p className="title">
                                        {emailContent.params[key]} - ({key})
                                      </p>
                                      <div className="input-wrapper">
                                        <label className="input">
                                          <input
                                            type="text"
                                            value={param[key] || ""}
                                            id={key}
                                            onChange={(e) => {
                                              if (
                                                key == "param1" &&
                                                regexService.isAmount(
                                                  e.target.value
                                                )
                                              ) {
                                                setParamValue(e);
                                              } else if (
                                                key != "param1" &&
                                                regexService.isAlphaNum(
                                                  e.target.value
                                                )
                                              ) {
                                                setParamValue(e);
                                              }
                                              {
                                              }
                                            }}
                                          />
                                        </label>
                                        {isError?.includes(key) && (
                                          <p className="help-text text-danger mt-1">
                                            Required field*
                                          </p>
                                        )}
                                      </div>
                                    </>
                                  );
                                }
                              })}
                            {emailContent?.params &&
                              Object?.values(emailContent?.params)?.includes(
                                "link"
                              ) && (
                                <>
                                  <p className="title">
                                    Paymentlink - (
                                    {Object.keys(emailContent?.params).find(
                                      (key) =>
                                        emailContent?.params[key] === "link"
                                    )}
                                    )
                                  </p>
                                  <div className="input-wrapper">
                                    <p className="bg-100 p-1 mini-text text-700">
                                      Payment Link will be auto generated
                                    </p>
                                  </div>
                                </>
                              )}
                          </div>
                          {emailContent?.mail_content && (
                            <div className="input-wrapper text-right">
                              <p
                                className="f-600 text-primary cursor-pointer mini-text"
                                onClick={previewModal.showModal}
                              >
                                Preview Template
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fc-12 text-right mt-5">
            {(isError?.length > 0 && (
              <button className="btn-disabled">Send</button>
            )) || (
              <button className="btn-primary " onClick={() => submitInvoice()}>
                Send{" "}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}

function ContentPreview({ context, param }) {
  Object.keys(param)?.map((e) => {
    context = context.replaceAll(
      "$" + `{${e}}`,
      (!param[e] && "$" + `{${e}}`) || param[e]
    );
  });

  return context;
}

function contentPreview(context, param) {
  Object.keys(param)?.map((e) => {
    context = context.replaceAll(
      "$" + `{${e}}`,
      (!param[e] && "$" + `{${e}}`) || param[e]
    );
  });

  return context;
}

function DeliveryChip({ sms,email,ws, smsStatus = false,emailStatus = false,whatsappStatus=false }) {
  return(
    <>
    {sms==="Y"&&<StatusChip status={(smsStatus && "1") || "0"} value="SMS" />}
    {email==="Y"&&<StatusChip status={(emailStatus && "1") || "0"} value="Email" />}
    {ws==="Y"&&<StatusChip status={(whatsappStatus && "1") || "0"} value="Whatsapp" />}
    </>
  )
}

export default CreateInvoice;
